const APP_ROUTE_PREFIXES = ['/dashboard', '/users', '/authentication', '/settings'];

export const getStaticExportRedirectPath = (path: string | string[] | undefined): string | null => {
  const rawPath = Array.isArray(path) ? path[0] : path;

  if (!rawPath) {
    return null;
  }

  let decodedPath = rawPath;

  try {
    decodedPath = decodeURIComponent(rawPath);
  } catch {
    decodedPath = rawPath;
  }

  if (decodedPath.indexOf('loop=true') >= 0) {
    return '/404/';
  }

  return `/${decodedPath.replace(/^\/+/, '')}`;
};

export const isAppRoutePath = (path: string | null): boolean =>
  !!path && APP_ROUTE_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
